import styled from "styled-components";

export const ZeroStylesButton = styled.button`
  appearance: none;
  cursor: pointer;
  border: none;
  background: none;
`;
